import React, { Component, setState } from 'react';


export default function ContractRedirect() {

    return(
        <div>Contract Redirect Page</div>
    )

}